import { updateLocoScroll } from '../locomotive-scroll'

let $body = $('body')
let $block = $('#top-5')
let activeClass = 'is-active'
let categorySwitch = '.js-switch-top-five-category'
let activeCategory = `${categorySwitch}.${activeClass}`
let toggleVisibleClass = 'is-visible'
let toggleObjects = '.toggle-rank-category'
let toggleSingleCategory = '.js-rank-category-'

function switchTopFiveRankingColorCode()
{
  $block.attr('data-rank-color', $(activeCategory).attr('data-color-code'))
}


$body.on('click', categorySwitch, function (e) {

  e.preventDefault()
  let $this = $(this)
  $(categorySwitch).removeClass(activeClass)
  $this.addClass(activeClass)
  switchTopFiveRankingColorCode()


  let categoryId = $this.data('rank-category')
  $(toggleObjects).removeClass(toggleVisibleClass)
  $(`${toggleSingleCategory}${categoryId}`).addClass(toggleVisibleClass)

  updateLocoScroll()

})

switchTopFiveRankingColorCode()
